import type { CheckBrandNameResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { checkBrandNameKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useCheckBrandName(
  projectId: number,
  name: string,
): UseQueryResult<CheckBrandNameResponse> {
  return useQuery<CheckBrandNameResponse>({
    enabled: !!projectId && name.trim().length > 0,
    queryFn: () =>
      apiClient
        .url(`/brands/${projectId}/check-name`)
        .query({ name: name.trim() })
        .get()
        .json<CheckBrandNameResponse>(),
    queryKey: checkBrandNameKeys.check(projectId, name.trim()),
    staleTime: 10_000,
  });
}
